module.exports = __webpack_public_path__ + "img/AdobeStock_449007164.c01a18a5.jpeg";